import { render, staticRenderFns } from "./AccountTree.vue?vue&type=template&id=cbb528de&scoped=true"
import script from "./AccountTree.vue?vue&type=script&lang=js"
export * from "./AccountTree.vue?vue&type=script&lang=js"
import style0 from "./AccountTree.vue?vue&type=style&index=0&id=cbb528de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb528de",
  null
  
)

export default component.exports